enum SeedClassRoutes {
  List = '/seed-classes',
  Add = '/seed-classes/add',
  Edit = '/seed-classes/edit/:id',
}

export default SeedClassRoutes
